<template>
    <div>
        <UserTable @newdata="handleData($event)"></UserTable>
        <div class="columns ">
            <div class="column is-6">
                <b-field label="Пользователь">
                    <b-select expanded placeholder="Выберите пользователя"
                              v-model="postback.aff_sub2">
                        <option
                            v-for="item in users"
                            :value="item.uuid"
                            :key="item.name">
                            {{ item.name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Application">
                    <b-select expanded placeholder="Application" v-model="postback.aff_sub3">
                        <option
                            v-for="item in applications"
                            :value="item.aff_sub3"
                            :key="item.aff_sub3">
                            {{ item.aff_sub3 }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Оффер">
                    <b-select expanded placeholder="Выберите оффер" v-model="postback.aff_sub">
                        <option
                            v-for="item in offers"
                            :value="item.id"
                            :key="item.id">
                            {{ item.name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Статус">
                    <b-select expanded placeholder="Выберите статус" v-model="postback.status">
                        <option
                            v-for="item in stauses"
                            :value="item"
                            :key="item">
                            {{ item }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Сумма выплаты">
                    <b-input v-model="postback.payout"></b-input>
                </b-field>

                <b-field label="Валюта">
                    <b-select expanded placeholder="Выберите валюту" v-model="postback.currency">
                        <option
                            v-for="item in currencys"
                            :value="item"
                            :key="item">
                            {{ item }}
                        </option>
                    </b-select>
                </b-field>
            </div>

            <div class="column is-6 ">
                <b-button @click="sendPostback()" type="is-primary" icon-right="chevron-right">
                    Отправить постбэк
                </b-button>
                <pre>{{postback}}</pre>
            </div>
        </div>
    </div>
</template>

<script>
    import {AxiosClient} from "@/app/shared/services";
    import UserTable from '@/app/admin/users/shared/components/userTable';

    export default {
        name: 'PostbackEmulator',
        components: {
            UserTable
        },
        data() {
            return {
                postback: {
                    aff_sub: '',
                    aff_sub2: '',
                    aff_sub3: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
                    status: 'pending',
                    payout: 0,
                    currency: '',
                },
                users: [],
                applications: [],
            }
        },
        computed: {
            offers() {
                return this.$store.getters.OFFERS;
            },
            stauses() {
                return ['pending', 'rejected', 'approved']
            },
            currencys() {
                return ['RUB', 'EUR', 'USD']
            },
        },
        methods: {
            handleData(data) {
                this.users = data
            },
            validate() {
                var valid = true;
                for (const item of Object.values(this.postback)) {
                    if (item.length == 0)
                        valid = false
                }
                return valid
            },
            sendPostback() {
                if (this.validate()) {
                    AxiosClient.get('/postback/handle', {params: this.postback})
                        .then((data) => {
                            this.$toaster.success('Постбек отправлен');
                        })
                        .catch(() => {
                            this.$toaster.error('Ошибка!');
                        })
                } else {
                    this.$toaster.error('Ошибка!');
                }
            },
            getApplications() {
                const params = {
                    uuid: this.postback.aff_sub2
                };
                AxiosClient.get('/applications/get_applications_by_user', {params: params})
                    .then((data) => {
                        this.applications = data.data;
                    })
                    .catch((error) => {
                        this.$toaster.error('Ошибка!' + error);
                    })
            }
        },
        watch: {
            'postback.aff_sub2': function () {
                this.getApplications()
            }
        }
    }
</script>
